import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { workflowApprovalsApi } from '@/api/workflowApprovals'
import { useTenantKey } from './useTenantKey'

export function usePendingApprovals(projectId: string) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('projects', projectId, 'workflow-approvals', 'pending'),
    queryFn: () => workflowApprovalsApi.getPending(projectId),
    enabled: !!projectId,
  })
}

export function useApprovePhase(projectId: string) {
  const queryClient = useQueryClient()
  const tenantKey = useTenantKey()
  return useMutation({
    mutationFn: ({ phaseId, comment }: { phaseId: string; comment?: string }) =>
      workflowApprovalsApi.approve(projectId, phaseId, comment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'workflow-runs') })
      queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'workflow-approvals', 'pending') })
    },
  })
}

export function useRejectPhase(projectId: string) {
  const queryClient = useQueryClient()
  const tenantKey = useTenantKey()
  return useMutation({
    mutationFn: ({ phaseId, reason }: { phaseId: string; reason: string }) =>
      workflowApprovalsApi.reject(projectId, phaseId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'workflow-runs') })
      queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'workflow-approvals', 'pending') })
    },
  })
}
